import React, { forwardRef } from 'react';
import { Box, Text } from '@chakra-ui/react';
import { TbTrash } from 'react-icons/tb';

const FileContextMenu = forwardRef(({ file, onMarkAsIndex, onMarkAsSource, onRename, onDelete, onDownloadFile, onDownloadSource, onDownloadTrackTex }, ref) => {

    const isTexFile = file?.name && file.name.toLowerCase().endsWith('.tex');
    const hasSource = Boolean(file?.has_source || file?.proof_content);
    const hasTrack = Boolean(file?.has_track);

    const ContextMenuItem = ({ onClick, color, hoverBg, hoverColor, rightIcon, children }) => {
        return (
            <Box
                as="button"
                w="94%"
                textAlign="left"
                ml="3%"
                px="3"
                py="1.5"
                borderRadius="4px"
                cursor="pointer"
                bg="transparent"
                color={color || "#cccccc"}
                fontSize="13px"
                fontFamily="'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
                display="flex"
                alignItems="center"
                justifyContent={rightIcon ? "space-between" : "flex-start"}
                _hover={{
                    bg: hoverBg || "#094771",
                    color: hoverColor || "white"
                }}
                onClick={onClick}
                transition="none"
            >
                <Text isTruncated>
                    {children}
                </Text>
                {rightIcon && (
                    <Box as="span" ml={2} display="flex" alignItems="center">
                        {rightIcon}
                    </Box>
                )}
            </Box>
        );
    };

    return (
        <Box
            ref={ref}
            className='more_option'
            position="absolute"
            top="25px"
            right="10px"
            minW="180px"
            bg="#252526"
            border="1px solid #454545"
            boxShadow="0px 4px 6px rgba(0, 0, 0, 0.3)"
            borderRadius="4px"
            py="4px"
            zIndex={10000}
            display="flex"
            flexDirection="column"
        >
            {(!file.is_index) && (
                <ContextMenuItem onClick={onMarkAsIndex}>
                    Mark as Index
                </ContextMenuItem>
            )}

            <ContextMenuItem onClick={onMarkAsSource}>
                Make as source
            </ContextMenuItem>

            <ContextMenuItem onClick={onRename}>
                Rename
            </ContextMenuItem>

            <Box w="90%" h="1px" bg="#454545" mx="auto" my="4px" />

            <ContextMenuItem onClick={onDownloadFile}>
                Download File
            </ContextMenuItem>

            {hasSource && (
                <ContextMenuItem onClick={onDownloadSource}>
                    Download Source
                </ContextMenuItem>
            )}

            {isTexFile && hasTrack && (
                <ContextMenuItem onClick={onDownloadTrackTex}>
                    Download Track TeX
                </ContextMenuItem>
            )}

            <Box w="90%" h="1px" bg="#454545" mx="auto" my="4px" />

            <ContextMenuItem
                onClick={onDelete}
                color="#f87171"
                hoverBg="#c53030"
                hoverColor="white"
                rightIcon={<TbTrash size="15px" />}
            >
                Delete
            </ContextMenuItem>
        </Box>
    );
});

export default FileContextMenu;
